export default __webpack_public_path__ + "static/webRotator/svg/3d4edbc5e62d83ac6e9add0a7c92d14c.svg";